module.exports = __webpack_public_path__ + "static/img/8.ce8892d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/8.png
// module id = 2qSR
// module chunks = 0